
import vars from "@exo/narrative-tracker-variables";

import { 
  ENTITY_TYPE_PERSON,
  ENTITY_TYPE_ORG,
  ENTITY_TYPE_VESSEL,
  ENTITY_TYPE_RESUME,
  ENTITY_TYPE_PROJECT,
} from "../../constants.js";

import {
  mdiAccount as PersonIcon,
  mdiOfficeBuilding as OrgIcon,
  mdiFerry as VesselIcon,
  mdiAccountFileText as ResumeIcon,
  mdiClipboardTextClock as ProjectIcon,
  mdiArrowTopRightThinCircleOutline as EdgeIcon,
  mdiHelp as UnknownIcon,
 } from '@mdi/js';

 const AI_NODE_LABEL_OPACITY = "0.5";
 const NODE_ICON_COLOR_DARK = vars.charcoal_3;
 const NODE_ICON_COLOR_LIGHT = "#FFFFFF";

 export const DATA_TYPE_CURATED = "curated";
 export const DATA_TYPE_AGENT_GENERATED = "AI generated";

 export const FALayoutSettings = {
  barnesHutOptimize: false,
  strongGravityMode: true,
  gravity: 0.03, 
  scalingRatio: 10, 
  slowDown: 5,
}

export const isAINode = (node) => {
  return node?.attributes?.creation_source === "Agent Generated";
  // return node?.attributes?.label === "FIRMA VEARDON OOO" 
  //   || node?.attributes?.label === "AVANFORT OOO" 
  //   || node?.attributes?.label === "Igor Ivanovich Shuvalov"
  //   || node?.attributes?.label === "ZARECHE-4 OOO";
}

export const isAIEdge = (edgeKey, graph) => {
  try {
    const sourceNode = graph.source(edgeKey);
    const targetNode = graph.target(edgeKey);
    if (sourceNode && targetNode) {
      const sourceAttribs = graph.getNodeAttributes(sourceNode);
      const targetAttribs = graph.getNodeAttributes(targetNode);
      return isAINode(sourceAttribs) || isAINode(targetAttribs);
    }
  }
  catch {
    return false;
  }
}

 export const getEdgeIcon = (edgeType) => {
  switch (edgeType) {
    default: return EdgeIcon;
  }
}
 
export const getNodeIcon = (nodeType) => {
  const def = UnknownIcon;
  if (nodeType) {
    switch (nodeType.toUpperCase()) {
      case ENTITY_TYPE_PERSON.toUpperCase(): return PersonIcon;
      case ENTITY_TYPE_ORG.toUpperCase(): return OrgIcon;
      case ENTITY_TYPE_VESSEL.toUpperCase(): return VesselIcon;
      case ENTITY_TYPE_RESUME.toUpperCase(): return ResumeIcon;
      case ENTITY_TYPE_PROJECT.toUpperCase(): return ProjectIcon;
      default: return def;
    }
  }
  return def;
}

export const getNodeImage = (nodeType, darkUI) => {
  const def = darkUI ? "/src/static/graphs/unknown_dark.svg" : "/src/static/graphs/unknown.svg";
  if (nodeType) {
    switch (nodeType.toUpperCase()) {
      case ENTITY_TYPE_PERSON.toUpperCase(): return darkUI ? "/src/static/graphs/person_dark.svg" : "/src/static/graphs/person.svg"; 
      case ENTITY_TYPE_ORG.toUpperCase(): return darkUI ? "/src/static/graphs/organization_dark.svg" : "/src/static/graphs/organization.svg"; 
      case ENTITY_TYPE_VESSEL.toUpperCase(): return darkUI ? "/src/static/graphs/vessel_dark.svg" : "/src/static/graphs/vessel.svg"; 
      case ENTITY_TYPE_RESUME.toUpperCase(): return darkUI ? "/src/static/graphs/resume_dark.svg" : "/src/static/graphs/resume.svg"; 
      case ENTITY_TYPE_PROJECT.toUpperCase(): return darkUI ? "/src/static/graphs/project_dark.svg" : "/src/static/graphs/project.svg"; 
      default: return def;
    }
  }
  return def;
}

export const getNodeColor = (nodeType, isSourceNode, darkUI) => {
  const def = "#DB4139";
  if (isSourceNode) {
    return darkUI ? "#E0E0E0" : "#404040";
  }
  else if (nodeType) {
    switch (nodeType.toUpperCase()) {
      case ENTITY_TYPE_VESSEL.toUpperCase(): return darkUI ? "#009E73": "#66C2A5";
      case ENTITY_TYPE_ORG.toUpperCase(): return darkUI ? "#56B4E9" : "#5F83CC";
      case ENTITY_TYPE_PERSON.toUpperCase(): return darkUI ? "#E69F00" : "#FE8503";
      case ENTITY_TYPE_RESUME.toUpperCase(): return darkUI ? "#c96965": "#B0413E";
      case ENTITY_TYPE_PROJECT.toUpperCase(): return darkUI ? "#4C9F70" : "#4C9F70";
      default: return def;
    }
  }
  return def;
}

export const getNodeReducedColor = (nodeType, isSourceNode, darkUI) => {
  const def = "#DB4139";
  if (isSourceNode) {
    return darkUI ? "#E0E0E0" : "#404040";
  }
  else if (nodeType)  {
    switch (nodeType.toUpperCase()) {
      case ENTITY_TYPE_VESSEL.toUpperCase(): return darkUI ? "#003829": "#afdfd0";
      case ENTITY_TYPE_ORG.toUpperCase(): return darkUI ? "#136593" : "#99b0de";
      case ENTITY_TYPE_PERSON.toUpperCase(): return darkUI ? "#805800" : "#feb669";
      case ENTITY_TYPE_RESUME.toUpperCase(): return darkUI ? "#d99794": "#d38381";
      case ENTITY_TYPE_PROJECT.toUpperCase(): return darkUI ? "#2b5a3f" : "#8ac7a4";
      default: return "#DB4139";
    }
  }
  return def;
}

export const getNodeOpacityColor = (nodeType, isSourceNode, darkUI, opacity) => {
  const def = `rgba(219, 65, 57, ${opacity})`;
  if (isSourceNode) {
    return darkUI ? `rgba(224, 224, 224, ${opacity})` : `rgba(64, 64, 64, ${opacity})`;
  }
  else if (nodeType) {
    switch (nodeType.toUpperCase()) {
      case ENTITY_TYPE_VESSEL.toUpperCase(): return darkUI ? `rgba(0, 158, 115, ${opacity})`: `rgba(102, 194, 165, ${opacity})`;
      case ENTITY_TYPE_ORG.toUpperCase(): return darkUI ? `rgba(86, 180, 233, ${opacity})` : `rgba(95, 131, 204, 0${opacity})`;
      case ENTITY_TYPE_PERSON.toUpperCase(): return darkUI ? `rgba(230, 159, 0, ${opacity})` : `rgba(254, 133, 3, ${opacity})`;
      case ENTITY_TYPE_RESUME.toUpperCase(): return darkUI ? `rgba(191, 154, 202, ${opacity})` : `rgba(104, 50, 87, ${opacity})`;
      case ENTITY_TYPE_PROJECT.toUpperCase(): return darkUI ? `rgba(76, 159, 112, ${opacity})` : `rgba(76, 159, 112, ${opacity})`;
      default: return def;
    }
  }
  return def;
}

export const getNodeMenuColor = (nodeType, isSourceNode, darkUI) => {
  return getNodeOpacityColor(nodeType, isSourceNode, darkUI, 0.8);
}

export const getNodeGraphColor = (node, isSourceNode, darkUI) => {
  const nodeType = node?.attributes?.entityType;
  if (isAINode(node)) {
    return getNodeReducedColor(nodeType, isSourceNode, darkUI);
  }
  else {
    return getNodeColor(nodeType, isSourceNode, darkUI);
  }
}

export const getNodeBorderColor = (node, isSourceNode, darkUI) => {
  const baseColor = darkUI ? vars.charcoal_2 : vars.grey_2;
  const reducedColor = darkUI ? vars.grey_5 : vars.grey_1;
  return isAINode(node) ? reducedColor : baseColor;
}

export const getNodeIconColor = (isSourceNode, darkUI) => {
  return darkUI ? NODE_ICON_COLOR_DARK : NODE_ICON_COLOR_LIGHT;
}

export const getEdgeColor = (edgeKey, edge, darkUI, graph) => {
  const baseEdgeColor = darkUI ? vars.grey_3 : vars.grey_1_25;
  const reducedEdgeColor = darkUI ? vars.grey_4 : vars.grey_0_5;
  return isAIEdge(edgeKey, graph) ? reducedEdgeColor : baseEdgeColor;
}

export const getEdgeMenuColor = (edgeType, darkUI) => {
  return darkUI ? vars.grey_3_5 : vars.grey_1;
}

export const getSelectedEdgeColor = (edgeKey, edge, darkUI, graph) => {
  const baseEdgeColor = darkUI ? vars.grey_3 : vars.grey_1_25;
  const reducedEdgeColor = darkUI ? vars.grey_4 : vars.grey_0_5;
  return isAIEdge(edgeKey, graph) ? reducedEdgeColor : baseEdgeColor;
}

export const getEdgePrintColor = (edgeType, darkUI) => {
  return darkUI ? vars.grey_3_5 : vars.grey_1_4;
}

export const getLabelColor = (darkUI) => {
  return darkUI ? vars.sky_2 : vars.text_2;
}

export const getNodeLabelColor = (node, darkUI) => {
  const baseColor = darkUI ? vars.sky_2 : vars.text_2;
  return !isAINode(node) ? baseColor : hexToRGB(baseColor, AI_NODE_LABEL_OPACITY);
}

export const hexToRGB = (hex, alpha) => {
  if (!hex) {
    return null;
  }
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  if (alpha) {
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  } else {
    return `rgb(${r}, ${g}, ${b})`;
  }
}